<ng-container
  *ngIf="
    dataConcessionScenario === 'Manual' ||
    (dataConcessionScenario === 'Mixed' && concessionManagementDataValidationForm?.isRegisterForDistrictHeating)
  ">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
    <h4 class="section-title">{{ 'basic-profile.fields.company-related-documents' | translate }}</h4>
    <hr />
  </div>

  <ng-container *ngFor="let documentType of takeMandatoryDocumentsTypes">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
      <app-file
        [documents]="documents"
        [fileType]="documentType"
        (fileEvent)="fileEvent()"
        [isRequired]="!optionalDocumentsTypes.has(documentType)"
        [taId]="technicianApplication.ta_id"
        [uploadDisabled]="!companyDataFG?.value.company_id"
        [autosave]="autosave"
        (onFileUploading)="uploadFile($event)"
        (onFileDeleting)="deleteFile($event)"></app-file>
    </div>
  </ng-container>
</ng-container>

<ng-container
  *ngIf="
    dataConcessionScenario === 'Manual' ||
    (dataConcessionScenario === 'Mixed' && concessionManagementDataValidationForm?.isRegisterForDistrictHeating)
  ">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
    <h4 class="section-title">{{ 'basic-profile.fields.technician-related-documents' | translate }}</h4>
    <hr />
  </div>

  <ng-container *ngFor="let documentType of specialistMandatoryDocumentsTypes">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
      <app-file
        [documents]="documents"
        [fileType]="documentType"
        (fileEvent)="fileEvent()"
        [isRequired]="!optionalDocumentsTypes.has(documentType)"
        [taId]="technicianApplication.ta_id"
        [autosave]="autosave"
        (onFileUploading)="uploadFile($event)"
        (onFileDeleting)="deleteFile($event)"></app-file>
    </div>
  </ng-container>

  <div *ngIf="showSafetyTechnologyExemptionDocument" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
    <app-file
      [documents]="documents"
      [fileType]="'safety_technology_exemption'"
      (fileEvent)="fileEvent()"
      [taId]="technicianApplication.ta_id"
      [autosave]="autosave"
      (onFileUploading)="uploadFile($event)"
      (onFileDeleting)="deleteFile($event)"></app-file>
  </div>

  <div *ngIf="showSafetyTechnologyAuthorizationDocument" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
    <app-file
      [documents]="documents"
      [fileType]="'safety_technology_authorization'"
      (fileEvent)="fileEvent()"
      [taId]="technicianApplication.ta_id"
      [autosave]="autosave"
      (onFileUploading)="uploadFile($event)"
      (onFileDeleting)="deleteFile($event)"></app-file>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
    <h4 class="section-title">{{ 'basic-profile.fields.other_documents' | translate }}</h4>
    <hr />
  </div>

  <div class="ui-g-12 form-column">
    <app-nested-file [taId]="technicianApplication.ta_id" [documents]="documents" (fileEvent)="fileEvent()"></app-nested-file>
  </div>
</ng-container>
